export default __webpack_public_path__ + "static/media/Minus.e82c2372.svg";